code

<template>

  <div class="container">
    <div class="row fh-row justify-content-center">
      <div class="col-md-6 pl-0 pr-0 align-self-center">
        <mdb-card class="z-depth-1 card-height">
          <mdb-card-header color="white">
            <div class="container-fluid">
              <div class="row">
                <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                  <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                  <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                  <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                </div>
              </div>
            </div>
          </mdb-card-header>
          <mdb-card-body class="text-center">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 align-self-center">
                  <mdb-progress class="mb-3" style="width: 100%; float:left"
                                :height="20" :value="$store.state.step/$store.state.totalSteps * 100">
                    {{ $store.state.step }}/{{ $store.state.totalSteps }}
                  </mdb-progress>
                </div>
              </div>
              <div class="hh-row">
                <div>
                  <h3>{{ $t("undertaking") }}</h3>
                  <mdb-card class="mb-2">
                    <div class="file-content">
                      <div>
                        <VueDocPreview v-if="!showMore" :value="shortFileContent" type="markdown" />
                        <vue-pdf-embed v-if="showMore && largeFileContent && !largeFileContentError"
                                       @rendered="spinner=false" :source="'data:application/pdf;base64,' + largeFileContent" />
                        <VueDocPreview v-if="showMore && largeFileContentError"
                                       :value="largeFileContent" type="markdown" />
                      </div>
                    </div>
                  </mdb-card>
                </div>
              </div>
            </div>
<!--            <div class="col-12 align-self-center">-->
<!--              <div class="row justify-content-center">-->
<!--                <div class="col-md-4 mb-2">-->
<!--                  <mdb-btn style="font-size: 15px" block color="white" class="btn-outline-primary" size="md" @click="showMore=!showMore">-->
<!--                    {{ showMore? $t("less"): $t("more") }}-->
<!--                  </mdb-btn>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </mdb-card-body>
          <mdb-card-footer>
            <div class="col-12 align-self-center">
              <div class="row justify-content-center">
                <div class="col-md-12 mb-1 ">
                  <mdb-btn style="font-size: 15px" block color="danger" class="next-btn" size="md" @click="navigate(false)">
                    {{ $t("cancel") }}
                    <i style="font-size: 22px" class="fa-times fas fa-2x float-right" />
                  </mdb-btn>
                </div>
                <div class="col-md-12 mb-1 ">
                  <mdb-btn style="font-size: 15px" block color="primary" class="next-btn" size="md" @click="navigate(true)">
                    {{ $t("accept") }}
                    <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                  </mdb-btn>
                </div>
              </div>
            </div>
          </mdb-card-footer>
        </mdb-card>
      </div>
    </div>
    <div id="overlay" v-if="spinner">
      <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>

        </div>
        <p>{{ $t("waitMsg") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import VueDocPreview from 'vue-doc-preview';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import {i18n} from "../../translations";


export default {
  name: "Undertaking",
  components: {
    VuePdfEmbed,
    VueDocPreview
  },
  data() {
    return {
      spinner: false,
      fileContent: null,
      largeFileContent: null,
      showMore: false,
      shortFileContent: null,
      shortFileToRender: null,
      fileToRender: null,
    };
  },
  computed: {
    largeFileContentError() {
      return ['No File Found', 'Download Error'].includes(this.largeFileContent)
    }
  },
  mounted() {
    i18n.locale = this.$store.state.language
    this.$store.commit('assignStep', this.$route.path)
    // if (this.$store.state.language === 'ur') {
    //   this.shortFileToRender = '/media/urdu.md'
    //   this.fileToRender = '/media/ConventionalTnc-ur.pdf'
    // } else {
    //   this.shortFileToRender = '/media/short.md'
    //   this.fileToRender = '/media/ConventionalTnc-en.pdf'
    // }
    this.getContent()
  },
  methods: {
    navigate(accept) {
      this.spinner = true;
      let formData = new FormData();
      formData.append('session', this.$store.state.session_id);
      formData.append('accept', accept);
      this.$http.post("/undertaking", formData).then(r => {
        if (accept === true) {
          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
        } else {
          this.$router.push('/complete')
        }
        this.spinner = false
      }).catch(err => {
        this.handleError(err)
      })
    },
    handleError(err) {
      this.spinner = false;
      if (err.response.status === 400){
        if ('non_field_errors' in err.response && err.response.non_field_errors.length>0){
          this.showError(err.response.non_field_errors[0])
        }
        else if ('data' in err.response){
          if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length>0){
            this.showError(err.response.data.non_field_errors[0])
          }
          else{
            this.showError(JSON.stringify(err.response.data))
          }

        }
        else{
          this.showError(JSON.stringify(err.response))
        }
      } else if (err.response && err.response.status === 401) {
        this.$router.push('/expired')
      }
      else {
        this.showError(err.response)
      }
    },
    showError(message, cancelButton=false) {
      const options = {
        title: message,
        text: this.$t("retryQuestion"),
        icon: 'question',
        showCancelButton: cancelButton,

        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary btn-md ripple-parent",
          cancelButton: "btn  btn-md ripple-parent"
        },
        buttonsStyling: false,
      };

      this.$swal.fire(options).then(res => {
        if (res.value) {
          window.location.reload();
          // eslint-disable-next-line no-undef
        }
      })

    },
    getContent() {
      this.spinner = true
      this.$http.get("/undertaking").then(res => {

        if (res.data.short_undertaking) {
          this.shortFileContent = res.data.short_undertaking
        } else {
          this.shortFileContent = "No File Found"
        }

        this.largeFileContent = res.data.detail_undertaking? res.data.detail_undertaking: "No File Found"
        this.spinner = false
      }).catch(err => {
        this.spinner = false
        this.shortFileContent = "Download Error"
        this.largeFileContent = "Download Error"
        this.handleError(err)
      })
      // this.$http.get(this.fileToRender, {
      //   responseType: 'blob'
      // }).then(res => {
      //   const file = new Blob(
      //       [res.data],
      //       {type: 'application/pdf'});
      //   this.largeFileContent = URL.createObjectURL(file);
      //   this.spinner = false
      // }).catch(err => {
      //   this.spinner = false
      // })
    }
  }
}
</script>

<style scoped>

</style>
